import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { GeneralInput, GeneralButton } from 'sharedComponents';
import { IconCheckedFilled, IconInfoFilled } from 'svgIcons/MotionPortalIcons';
import colors from 'theme/_colors.scss';
import { apiCallStatus } from 'helpers/constants';
import { MAX_SERIAL_NUMBER_LENGTH } from '../helpers';

const SingleDriveComponent = ({
    initialSerialNumber,
    originalSerialNumber,
    onValidationStateChange,
    onSerialNumberChange,
    model,
    actions
}) => {
    const { t: translate } = useTranslation();
    const [serialNumber, setSerialNumber] = useState(initialSerialNumber || '');
    const [isEdited, setIsEdited] = useState(false);
    const [hasValidationAttempted, setHasValidationAttempted] = useState(false);

    useEffect(() => {
        const hasChanged = serialNumber !== initialSerialNumber;
        setIsEdited(hasChanged);
        onValidationStateChange(hasChanged && serialNumber.trim().length > 0);
    }, [serialNumber, initialSerialNumber, onValidationStateChange]);

    useEffect(() => {
        const validationState = model?.validateSerialNumber;
        if (validationState && (validationState.isValid === true || validationState.isValid === false)) {
            setHasValidationAttempted(true);
        }
    }, [model?.validateSerialNumber?.isValid]);

    useEffect(() => {
        return () => {
            actions.clearValidationState();
            onValidationStateChange(false);
        };
    }, [actions]);

    const handleSerialNumberChange = (value) => {
        if (value.length >= MAX_SERIAL_NUMBER_LENGTH) {
            return;
        }
        setSerialNumber(value);
        setHasValidationAttempted(false);
        onSerialNumberChange(value);
        if (actions?.clearValidationState) {
            actions.clearValidationState();
        }
    };

    const handleValidate = () => {
        const oldSerialNumber = originalSerialNumber || initialSerialNumber || '';
        const newSerialNumber = (serialNumber || '').trim();
        const isMultiModuleDrive = false;
        const suffix = null;

        actions.validateSerialNumber(oldSerialNumber, newSerialNumber, suffix, isMultiModuleDrive);
    };

    return (
        <div className='assign__serialnumber__input-container'>
            <form>
                <div id='assign__serialnumber__label'>
                    {translate('ABB.Powertrain.Frontend.assignSerialNumberLabel')}
                </div>
                <div className='assign__serialnumber__input-wrapper'>
                    <div className='assign__serialnumber__input-wrapper__inner'>
                        <GeneralInput
                            className={`${model?.validateSerialNumber?.isValid === false ? 'assign__serialnumber__input--error' : ''} assign__serialnumber__input`}
                            placeholder={translate('ABB.Powertrain.Frontend.assignSerialNumberPlaceholderText')}
                            onChange={handleSerialNumberChange}
                            value={serialNumber}
                        />
                        {model?.validateSerialNumber?.isValid === true &&
                            <div className='assign__serialnumber__success-container'>
                                <IconCheckedFilled
                                    width={18}
                                    height={18}
                                    color={colors.jungleGreen}
                                    className='success-icon'
                                />
                                <span>{translate('ABB.Powertrain.Frontend.assignSerialNumberValidationSuccess')}</span>
                            </div>
                        }
                        {model?.validateSerialNumber?.isValid === false &&
                            <div className='assign__serialnumber__error-container'>
                                <IconInfoFilled
                                    width={18}
                                    height={18}
                                    color={colors.pomegranate}
                                    className='error-icon'
                                />
                                <span>{translate('ABB.Powertrain.Frontend.assignSerialNumberValidationfailed')}</span>
                            </div>
                        }
                    </div>
                    <GeneralButton
                        type='normal'
                        text={translate('ABB.Powertrain.Frontend.assignSerialNumberValidationButtonLabel')}
                        onClick={handleValidate}
                        disabled={!isEdited || !serialNumber.trim().length || hasValidationAttempted || model?.validateSerialNumber?.loadingStatus === apiCallStatus.LOADING}
                    />
                </div>
            </form>
        </div>
    );
};

SingleDriveComponent.propTypes = {
    initialSerialNumber: PropTypes.string,
    originalSerialNumber: PropTypes.string,
    onValidationStateChange: PropTypes.func.isRequired,
    onSerialNumberChange: PropTypes.func.isRequired,
    model: PropTypes.object,
    actions: PropTypes.object
};

export default SingleDriveComponent;
